export const API_LISTASMAESTRAS = 'API/LISTASMAESTRAS'
